"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.log = void 0;
function log() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  if (typeof process !== 'undefined' && typeof process.env !== 'undefined' && process.env.NODE_ENV === 'development') {
    console.log.apply(console, args);
  }
}
exports.log = log;